import { append, ifElse, includes, isNil, mergeRight, omit, remove } from 'ramda';
import { handleActions } from 'redux-actions';

import * as types from './actionTypes';

/**
	customFilterPageIds - is used when user is looking for task types by form filter
	quickFilterPageIds - is used when user is looking for task types by pill buttons
 */
const initialState = {
	byIds: {},
	customFilterPageIds: {},
	quickFilterPageIds: {},
	selectedAll: {},
	selectedTaskIds: {},
	typesSort: {},
	persistTypeTasksVisibleState: false,
};

const saveTaskTypeDetail = (state, { payload }) => {
	const byIds = {};

	payload &&
		// eslint-disable-next-line array-callback-return
		payload.map((item) => {
			byIds[item.id] = item;
		});

	return mergeRight(state, {
		byIds: mergeRight(state.byIds, byIds),
	});
};

const setPageIds = (state, { payload: { data, taskTypeId, filterType } }) =>
	mergeRight(state, {
		[filterType]: mergeRight(state[filterType], { [taskTypeId]: data }),
	});

const appendPageIds = (state, { payload: { data, taskTypeId, filterType } }) =>
	mergeRight(state, {
		[filterType]: mergeRight(state[filterType], {
			[taskTypeId]: [...state[filterType][taskTypeId], ...data],
		}),
	});

const setTaskView = (state, { payload: { taskId, viewed } }) => {
	return mergeRight(state, {
		byIds: mergeRight(state.byIds, {
			[taskId]: mergeRight(viewed ? state.byIds[taskId] : omit(['solver'], state.byIds[taskId]), {
				read: viewed,
			}),
		}),
	});
};

const selectTask = (state, { payload: { taskTypeId, taskId } }) =>
	mergeRight(state, {
		selectedTaskIds: mergeRight(state.selectedTaskIds, {
			[taskTypeId]: ifElse(
				includes(taskId),
				(data) => remove(state.selectedTaskIds[taskTypeId].indexOf(taskId), 1, data),
				append(taskId),
			)(state.selectedTaskIds[taskTypeId] || []),
		}),
	});

const clearSelectedTasks = (state, { payload }) =>
	mergeRight(state, {
		selectedTaskIds: !isNil(payload)
			? mergeRight(state.selectedTaskIds, {
					[payload]: [],
			  })
			: {},
	});

const selectAllTasks = (state, { payload: { taskTypeId, areSelected } }) =>
	mergeRight(state, {
		selectedAll: mergeRight(state.selectedAll, {
			[taskTypeId]: areSelected,
		}),
	});

const clearAllSelect = (state, { payload }) =>
	mergeRight(state, {
		selectedAll: !isNil(payload)
			? mergeRight(state.selectedAll, {
					[payload]: false,
			  })
			: {},
	});

const reset = () => initialState;

const setSort = (state, { payload: { sort, taskTypeId } }) => {
	return {
		...state,
		typesSort: {
			...state.typesSort,
			[taskTypeId]: sort,
		},
	};
};

const setPersistTypeTasksVisibleState = (state, { payload }) => {
	return {
		...state,
		persistTypeTasksVisibleState: payload?.persistTypeTasksVisibleState,
	};
};

const tasksReducer = {
	[types.SAVE_TASK_DETAIL]: saveTaskTypeDetail,
	[types.SET_PAGE_IDS]: setPageIds,
	[types.APPEND_PAGE_IDS]: appendPageIds,
	[types.SET_TASK_VIEW]: setTaskView,
	[types.SELECT_TASK]: selectTask,
	[types.CLEAR_SELECT_TASKS]: clearSelectedTasks,
	[types.SELECT_ALL_TASK]: selectAllTasks,
	[types.CLEAR_ALL_SELECT]: clearAllSelect,
	[types.RESET]: reset,
	[types.SET_SORT]: setSort,
	[types.SET_PERSIST_TYPE_TASKS_VISIBLE_STATE]: setPersistTypeTasksVisibleState,
};

export default handleActions(tasksReducer, initialState);
